module.exports = __webpack_public_path__ + "img/ipgone_page2.b690174a.png";